module.exports = vendor_b56098dd79ef0a035831;


//////////////////
// WEBPACK FOOTER
// external "vendor_b56098dd79ef0a035831"
// module id = 89
// module chunks = 3